import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnDestroy,
} from '@angular/core';
import { AnalyticsService } from '../../../../services/analytics.service';
import { GTMTracking } from '../../../../enums/google-analytics-tracking';

@Component({
  selector: 'resend-countdown',
  template: `
    <ng-container>
      <p *ngIf="!secondsLeft" id="resendOtpLink">
        {{ text }}
        <a
          href="#"
          id="resendLink"
          aria-labeledby="resendOtpLink + resendLink"
          [ngClass]="{ disabled: linkClicked }"
          (click)="resentClicked($event)"
        >
          {{ resendLinkText }}
        </a>
      </p>
      <div *ngIf="secondsLeft > 0">
        Please wait {{ secondsLeft }} second{{ secondsLeft > 1 ? 's' : '' }}
        before trying to resend
      </div>
    </ng-container>
  `,
})
export class ResendCountdownComponent implements OnDestroy {
  @Input()
  seconds: number = 60;
  @Input()
  text: string;
  @Input()
  resendLinkText: string;
  @Input()
  formName: string;
  @Output()
  onResentRequested = new EventEmitter<void>();
  linkClicked: boolean;
  secondsLeft: number;

  @Input() set resendSuccessful(val: boolean) {
    if (val) {
      this.linkClicked = false;
      this.startOtpResendCountdown();
    }
  }

  private intervalId: number;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  resentClicked(event: Event): void {
    event.preventDefault();
    this.linkClicked = true;

    this.onResentRequested.emit();
    if (this.formName === 'register') {
      this.analyticsService.trackCtaActions(GTMTracking.ResendOrn);
    }
  }

  private startOtpResendCountdown(): void {
    this.secondsLeft = this.seconds;

    this.intervalId = setInterval(
      (() => {
        this.secondsLeft = this.secondsLeft - 1;

        if (this.secondsLeft == 0) {
          this.secondsLeft = undefined;
          clearInterval(this.intervalId);
        }
      }) as TimerHandler,
      1000
    );
  }
}
